@if (asset ) {
<div class="drawer">
  <div class="drawer__backdrop" (click)="onClose()"></div>
  <div class="drawer__panel" [class.drawer__panel--fullscreen]="isFullScreen">
    <!-- HEADER -->
    <div class="drawer__header">
      <div class="title-container">
        <div class="title">
          @if (assetSiteName) {
            <span class="title-site">{{ assetSiteName }}</span>
            <span class="title-separator"> &gt; </span>
          }
          <span class="title-entity">{{ asset?.label }}</span>
        </div>
      </div>
      <!-- Icons after title -->
      <div class="icons-container">
        <span
          class="investment-btn"
          (click)="openCostDialog()"
          style="cursor: pointer;"
          [style.opacity]="assetInvestmentsTotal > 0 ? '1' : '0.6'"
        >
          €({{ assetInvestmentsTotal }})
        </span>
        <span class="sheet-btn" (click)="openAssetSheet()" title="{{ 'asset_form_drawer.menu.open_fullscreen' | translate }}">
          <fa-icon icon="browsers"></fa-icon>
        </span>
        <span class="close-btn" (click)="onClose()">
          <i class="fa-light fa-x"></i>
        </span>
      </div>
    </div>

    <!-- TABS -->
    <div class="tabs-container">
      <div class="tabs-bar">
        <div class="tab" [class.active]="isActiveTab('descriptif')" [class.has-missing-data]="descriptifAlerts > 0 && shouldShowAlertCounts()" (click)="setActiveTab('descriptif')">
          <span class="tab-label">{{ "asset_form_drawer.tabs.descriptif" | translate }}</span>
        </div>
        <div class="tab" [class.active]="isActiveTab('synthese')" [class.has-missing-data]="summaryAlerts > 0 && shouldShowAlertCounts()" (click)="setActiveTab('synthese')">
          <span class="tab-label">{{ "asset_form_drawer.tabs.cycle_de_vie" | translate }}</span>
        </div>
        @if (maintenanceManagementEnabled || complianceManagementEnabled) {
        <div class="tab" [class.active]="isActiveTab('conformite-maintenance')" [class.has-missing-data]="getCombinedMissingDataCount() > 0 && shouldShowAlertCounts()" (click)="setActiveTab('conformite-maintenance')">
          <span class="tab-label">{{ "asset_form_drawer.tabs.conformite_maintenance" | translate }}</span>
        </div>
        }
        @if (documentTabEnabled) {
        <div class="tab" [class.active]="isActiveTab('documents')" [class.has-missing-data]="(asset?.total_missing_documents ?? 0) > 0 && shouldShowAlertCounts()" (click)="setActiveTab('documents')">
          <span class="tab-label">{{ "asset_form_drawer.tabs.documents" | translate }}@if (docCount > 0) { ({{ docCount }})}</span>
        </div>
        }
      </div>

      <!-- Icons below tabs -->
      <div class="tabs-icons">
        <!-- Icons for DESCRIPTIF tab -->
        <div class="tab-icon-column" [class.active]="isActiveTab('descriptif')">
          @if (descriptifAlerts > 0 && shouldShowAlertCounts()) {
            <div class="tab-icon-item">
              <span class="alert-count">({{ descriptifAlerts }})</span>
            </div>
          }
        </div>

        <!-- Icons for CYCLE DE VIE tab -->
        <div class="tab-icon-column" [class.active]="isActiveTab('synthese')">
          @if (summaryAlerts > 0 && shouldShowAlertCounts()) {
            <div class="tab-icon-item">
              <span class="alert-count">({{ summaryAlerts }})</span>
            </div>
          }
        </div>

        <!-- Icons for CONFORMITE/MAINTENANCE tab -->
        @if (maintenanceManagementEnabled || complianceManagementEnabled) {
          <div class="tab-icon-column" [class.active]="isActiveTab('conformite-maintenance')">
            @if (getCombinedMissingDataCount() > 0 && shouldShowAlertCounts()) {
              <div class="tab-icon-item">
                <span class="alert-count">({{ getCombinedMissingDataCount() }})</span>
              </div>
            }
          </div>
        }

        <!-- Icons for DOCUMENTS tab -->
        @if (documentTabEnabled) {
          <div class="tab-icon-column" [class.active]="isActiveTab('documents')">
            @if (missingMandatoryDocuments > 0 && shouldShowAlertCounts()) {
              <div class="tab-icon-item">
                <span class="alert-count">({{ missingMandatoryDocuments }})</span>
              </div>
            }
          </div>
        }
      </div>

    </div>

    <div class="content-container">
      <nb-card>
          <!-- TAB CONTENT -->
          <nb-card-body>
          <!-- DESCRIPTIF TAB -->
          @if (activeTab === 'descriptif') {
          <app-descriptif-tab
            [asset]="asset"
            [loading]="false"
            [canGoToAudit]="canGoToAudit"
            [equipmentValidationEnabled]="assetEquipmentValidation"
            (formChange)="onDescriptifFormChange($event)"
            (assetDataChanged)="onDescriptifAssetDataChanged()"
            (saveRequested)="onDescriptifSaveRequested()"
          ></app-descriptif-tab>
          }

          <!-- CYCLE DE VIE TAB -->
          <app-summary-tab
            [hidden]="activeTab !== 'synthese'"
            [asset]="asset"
            [loading]="false"
            [maintenanceManagementEnabled]="assetMaintenanceEnabled && maintenanceManagementValue"
            [equipmentValidationEnabled]="assetEquipmentValidation"
            (formChange)="onSummaryFormChange($event)"
            (assetDataChanged)="onSummaryAssetDataChanged()"
            (confirmationModalStateChanged)="onConfirmationModalStateChanged($event)"
            (requestSave)="onSummaryRequestSave()"
          ></app-summary-tab>



          <!-- CONFORMITE / MAINTENANCE TAB (MERGED) -->
          @if (activeTab === 'conformite-maintenance') {
            <!-- CONFORMITÉ SECTION FIRST -->
            @if (complianceManagementEnabled) {
              <div class="form-field toggle" style="margin-bottom: 24px; display: flex; align-items: center; justify-content: space-between; padding: 12px 10px; border-bottom: 1px solid #e4e9f2;">
                <label for="compliance_management" style="font-weight: 600; font-size: 14px; color: #222b45; margin: 0;">{{ "asset_form_drawer.compliance.equipment" | translate }}</label>
                <app-custom-toggle
                  id="compliance_management"
                  [checked]="complianceManagementValue"
                  (checkedChange)="onComplianceManagementChange($event)"
                  size="medium"
                ></app-custom-toggle>
              </div>
              <app-compliance-tab
                [asset]="asset"
                [loading]="false"
                [complianceManagementEnabled]="complianceManagementValue"
                [equipmentValidationEnabled]="assetEquipmentValidation"
                (formChange)="onComplianceFormChange($event)"
              ></app-compliance-tab>
            }

            <!-- MAINTENANCE SECTION SECOND -->
            @if (maintenanceManagementEnabled) {
              <div class="form-field toggle" style="margin-top: 32px; margin-bottom: 24px; display: flex; align-items: center; justify-content: space-between; padding: 12px 10px; border-bottom: 1px solid #e4e9f2;">
                <label for="maintenance_management" style="font-weight: 600; font-size: 14px; color: #222b45; margin: 0;">{{ "asset_form_drawer.maintenance.equipment" | translate }}</label>
                <app-custom-toggle
                  id="maintenance_management"
                  [checked]="maintenanceManagementValue"
                  (checkedChange)="onMaintenanceManagementChange($event)"
                  size="medium"
                ></app-custom-toggle>
              </div>
              <app-maintenance-tab
                [asset]="asset"
                [loading]="false"
                [maintenanceManagementEnabled]="maintenanceManagementValue"
                [equipmentValidationEnabled]="assetEquipmentValidation"
                (formChange)="onMaintenanceFormChange($event)"
              ></app-maintenance-tab>
            }
          }

          <!-- DOCUMENTS TAB -->
          @if (activeTab === 'documents') {
          <app-documents-tab
            [asset]="asset"
            (requestFullScreen)="toggleFullScreen($event)"
            (documentsChanged)="loadDocumentCount()"
          ></app-documents-tab>
          }
          </nb-card-body>
        </nb-card>

      @if (shouldShowSaveButton()) {
      <div class="sticky-save-container">
        <div class="sticky-save-button">
          <button nbButton type="button" (click)="onSave()" [disabled]="!isFormValid()">
            {{ "Save" | translate }}
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>

}

<app-investment-list-drawer
  [visible]="investmentDrawerVisible"
  [investmentIds]="investmentIds"
  [globalInvestments]="asset?.global_investments || []"
  [investmentData]="investmentData"
  [asset]="asset"
  [assetId]="asset?.id"
  (drawerClosed)="onInvestmentDrawerClosed()"
  (investmentSelected)="onInvestmentSelected($event)"
  (investmentsAttached)="onInvestmentsAttached($event)"
></app-investment-list-drawer>

